import { DefineNumberFormat } from "vue-i18n";

const defaultFormats: DefineNumberFormat = {
  decimal: {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  },
  percent: {
    style: "percent",
    useGrouping: false
  }
};

const de = {
  de: defaultFormats
};

const en = {
  en: defaultFormats
};

const fr = {
  fr: defaultFormats
};

export default {
  ...de,
  ...en,
  ...fr
};
